
import React, { useState } from 'react';
import { useSite } from '../context/SiteContext';
import { Waves, Utensils, Wifi, Users, MapPin, Shield, Car, ArrowRight, Maximize2, Coffee, Camera, Eye, X, Check, Mail, Phone, ExternalLink, ChevronLeft, ChevronRight, Navigation, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Room } from '../types';

export const Villa: React.FC = () => {
  const { rooms: contextRooms } = useSite();
  const [selectedRoom, setSelectedRoom] = useState<Room | null>(null);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const rooms = contextRooms.map(room => {
    if (room.name === 'Imperial Suite' || room.name === 'Deluxe Double Room') {
      return {
        ...room,
        name: 'Deluxe Double Room',
        image: 'https://lh3.googleusercontent.com/p/AF1QipOVOGr6GnXXusIHv5ckTIMcno8i4GbohBXIQ1uy=s1360-w1360-h1020-rw',
        images: [
          'https://lh3.googleusercontent.com/p/AF1QipOVOGr6GnXXusIHv5ckTIMcno8i4GbohBXIQ1uy=s1360-w1360-h1020-rw',
          'https://lh3.googleusercontent.com/p/AF1QipMFhzNZB1AxNCUrDpjoY5tsdvWbP7xrbLCzRY09=s1360-w1360-h1020-rw'
        ]
      };
    }
    if (room.name === 'Grand Family Pavilion' || room.name === 'Deluxe Family Room') {
      return {
        ...room,
        name: 'Deluxe Family Room',
        image: 'https://lh3.googleusercontent.com/p/AF1QipPNeWquPjT0j6KNq9fReclY2k_1N9noq35krBh2=s1360-w1360-h1020-rw',
        images: [
          'https://lh3.googleusercontent.com/p/AF1QipPNeWquPjT0j6KNq9fReclY2k_1N9noq35krBh2=s1360-w1360-h1020-rw',
          'https://lh3.googleusercontent.com/p/AF1QipPEDiSX3hPIllhnNaVRYkwRIFVjLP55UM1TNoQX=s1360-w1360-h1020-rw'
        ]
      };
    }
    return room;
  });

  const galleryPreview = [
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSxHcjSIeZWqL85SqS6vmSniAMS1S4iz-mERV5vy2MHBrvrFx4CYAPzEiCzlt9oGB5vMJ_GiVBQ9-z3WCsNOJghKNj5CFtJc5O-TxOarpcEUvJVonFsxBjuoznTTmTeL9zv8euQY=s1360-w1360-h1020-rw', size: 'md:col-span-2 md:row-span-2', title: 'Estate Grounds' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzK2qJOEkDX9h0y2MbqxvMHQ1z8SkU4fZb1YVCzGDuyDGkZv9eRnOe18tNzg87v4pBnBYyDUWDkjCI_D5oQiTUveDKPy-BUrVMfya-RNMnuKg-9cdZCeH074RXa6VZOKfQ1qHc=s1360-w1360-h1020-rw', size: 'md:col-span-2 md:row-span-1', title: 'Artisan Bath' },
    { url: 'https://lh3.googleusercontent.com/p/AF1QipMO_TYqQh42o3ICg3pyxgjRI6_dwEI0-4-9VAfK=s1360-w1360-h1020-rw', size: 'md:col-span-1 md:row-span-1', title: 'Evening Lounge' },
    { url: 'https://lh3.googleusercontent.com/p/AF1QipPrpBtqMtA0_2a8DpSp831w1Rqvc0tdf0l5YSXr=s1360-w1360-h1020-rw', size: 'md:col-span-1 md:row-span-1', title: 'Poolside Bliss' },
  ];

  const bookingUrl = "https://www.booking.com/hotel/lk/bevary-guest.html?aid=356980&label=gog235jc-10CAsohQFCDGJldmFyeS1ndWVzdEgzWANoO4gBAZgBM7gBF8gBDNgBA-gBAfgBAYgCAagCAbgC94C2ywbAAgHSAiQ3Zjk0ZWEyZC00YmVhLTQxMWEtYmVhNy01ZGRmMjNjMWY1MjjYAgHgAgE&sid=9f729016662e8d7217bc583ba81ccee3&age=0&all_sr_blocks=1314417102_404210285_2_0_0&checkin=2026-02-06&checkout=2026-02-07&dest_id=-2212786&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=1314417102_404210285_2_0_0&hpos=1&matching_block_id=1314417102_404210285_2_0_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=1314417102_404210285_2_0_0__1707&srepoch=1768783994&srpvid=d2b9063c15bd0128&type=total&ucfs=1&";

  const nextImage = () => {
    if (!selectedRoom?.images) return;
    setCurrentImgIndex((prev) => (prev + 1) % selectedRoom.images!.length);
  };

  const prevImage = () => {
    if (!selectedRoom?.images) return;
    setCurrentImgIndex((prev) => (prev - 1 + selectedRoom.images!.length) % selectedRoom.images!.length);
  };

  return (
    <div className="bg-[#0D0D0D]">
      {/* Immersive Villa Hero Section */}
      <section className="relative h-auto min-h-screen py-32 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0 bg-stone-900">
          <img 
            src="https://res.cloudinary.com/dxplhh55e/image/upload/v1768611243/Mandodari_Villa_Anuradhapura-39_Copy_wbxwhu.jpg" 
            className="w-full h-full object-cover"
            alt="The Mandodari Villa Estate"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/20 to-black/80"></div>
        </div>

        <div className="relative z-10 text-center px-6 w-full max-w-7xl mx-auto flex flex-col items-center justify-center">
          <h4 className="reveal active text-[#C5A059] text-[9px] md:text-xs font-light tracking-[0.6em] uppercase mb-4 md:mb-6 serif">
            SIGNATURE ACCOMMODATION
          </h4>
          
          <div className="relative mb-6">
            <h1 className="reveal active stagger-1 text-white text-5xl md:text-9xl lg:text-[11rem] font-bold serif leading-none tracking-tight">
              Mandodari
            </h1>
            <h2 className="reveal active stagger-2 absolute -bottom-6 md:-bottom-10 left-[58%] -translate-x-1/2 text-[#C5A059] text-4xl md:text-7xl lg:text-[7rem] italic serif font-medium opacity-95">
              Villa
            </h2>
          </div>

          <div className="reveal active stagger-3 mt-16 md:mt-24 mb-10 md:mb-14">
            <p className="text-white text-[8px] md:text-[12px] font-bold tracking-[0.4em] uppercase opacity-90">
              ANURADHAPURA • LUXURY COLLECTIVE
            </p>
          </div>

          <div className="reveal active stagger-3 grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-row items-center justify-center gap-4 md:gap-6 w-full max-w-6xl">
            <Link 
              to="/booking" 
              className="glow-button bg-[#C5A059] text-black px-8 py-4 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] shadow-2xl w-full lg:w-auto text-center transition-all duration-500 hover:scale-105"
            >
              INQUIRE FOR STAY
            </Link>
            <a 
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="glow-button bg-white text-black px-8 py-4 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] shadow-2xl w-full lg:w-auto text-center transition-all duration-500 hover:scale-105 flex items-center justify-center gap-2"
            >
              <ExternalLink size={14} /> BOOK ON BOOKING.COM
            </a>
            <Link 
              to="/menu" 
              className="glow-button bg-transparent border border-white/30 text-white hover:bg-white hover:text-black px-8 py-4 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] shadow-2xl backdrop-blur-md transition-all duration-500 w-full lg:w-auto text-center hover:scale-105"
            >
              VIEW MENU
            </Link>
            <a 
              href="https://maps.app.goo.gl/ZFWGsD7AVL5EqzucA"
              target="_blank"
              rel="noopener noreferrer"
              className="glow-button bg-transparent border border-white/30 text-white hover:bg-[#C5A059] hover:text-black hover:border-[#C5A059] px-8 py-4 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] shadow-2xl backdrop-blur-md transition-all duration-500 w-full lg:w-auto text-center hover:scale-105 flex items-center justify-center gap-2"
            >
              <MapPin size={14} /> LOCATE ON MAP
            </a>
          </div>
        </div>
      </section>

      {/* Intro & Specs */}
      <section className="py-20 md:py-40 bg-[#0D0D0D]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 md:gap-32 items-center">
            <div className="space-y-8 md:space-y-12">
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold serif leading-tight text-white">Ancient Soul. <br /> Modern <span className="text-[#C5A059]">Elegance.</span></h2>
              <p className="text-stone-400 leading-relaxed text-lg md:text-xl font-light">
                Designed for the world’s most elite travelers, Mandodari Villa is a sanctuary of quiet luxury. Located in the shadow of history, we offer a retreat that honors the past while providing every modern convenience.
              </p>
              <div className="grid grid-cols-2 gap-1">
                {[
                  { icon: <Users size={18} />, label: 'Up to 25 Guests' },
                  { icon: <Waves size={18} />, label: 'Heated Pool' },
                  { icon: <Shield size={18} />, label: 'Discreet Security' },
                  { icon: <MapPin size={18} />, label: 'Sacred Proximity' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 md:gap-5 p-6 md:p-10 bg-[#141414] border border-white/5">
                    <span className="text-[#C5A059]">{item.icon}</span>
                    <span className="font-black text-[8px] md:text-[10px] uppercase tracking-[0.1em] md:tracking-[0.2em] text-stone-400">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="relative group reveal stagger-2">
              <div className="aspect-[3/4] overflow-hidden luxury-shadow rounded-[2rem] md:rounded-[3rem] bg-stone-900 photo-glow">
                <img src="https://lh3.googleusercontent.com/gps-cs-s/AG0ilSxHcjSIeZWqL85SqS6vmSniAMS1S4iz-mERV5vy2MHBrvrFx4CYAPzEiCzlt9oGB5vMJ_GiVBQ9-z3WCsNOJghKNj5CFtJc5O-TxOarpcEUvJVonFsxBjuoznTTmTeL9zv8euQY=s1360-w1360-h1020-rw" className="w-full h-full object-cover transition-all duration-1000 scale-105 group-hover:scale-100" />
              </div>
              <div className="absolute -bottom-8 -left-8 bg-[#C5A059] p-8 md:p-12 rounded-2xl hidden lg:block luxury-shadow">
                <p className="text-black serif text-xl md:text-3xl italic leading-tight">"The finest stay in <br /> South Asia."</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Villa Location & Contact Info Section */}
      <section className="py-24 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-[#111] rounded-[3rem] border border-white/5 p-12 md:p-20 luxury-shadow reveal overflow-hidden relative">
            <div className="absolute top-0 right-0 w-96 h-96 bg-[#C5A059]/5 blur-[100px] rounded-full"></div>
            <div className="grid md:grid-cols-2 gap-16 md:gap-24 relative z-10">
              <div className="space-y-10">
                <div>
                  <h4 className="text-[#C5A059] uppercase tracking-[0.6em] font-black text-[9px] mb-6">The Sanctuary Details</h4>
                  <h2 className="text-4xl md:text-5xl serif text-white leading-tight">Mandodari Villa <br /><span className="italic font-medium text-[#C5A059]">Private Retreat.</span></h2>
                </div>
                
                <div className="space-y-8">
                  <div className="flex gap-6 items-start">
                    <MapPin className="text-[#C5A059] shrink-0 w-6 h-6" strokeWidth={1.5} />
                    <div>
                      <p className="text-white text-lg font-bold serif mb-2">Sanctuary Address</p>
                      <p className="text-stone-400 font-light leading-relaxed">395/12 A Mudhitha Mawatha, Anuradhapura 50000, Sri Lanka</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-6 items-start">
                    <Mail className="text-[#C5A059] shrink-0 w-6 h-6" strokeWidth={1.5} />
                    <div>
                      <p className="text-white text-lg font-bold serif mb-2">Inquiry Portal</p>
                      <p className="text-stone-400 font-light underline decoration-[#C5A059]/30 underline-offset-4">bevaryguest@gmail.com</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-[#161616] p-10 md:p-14 rounded-[2rem] border border-white/5">
                <h4 className="text-[#C5A059] uppercase tracking-[0.4em] font-black text-[9px] mb-8 text-center">Concierge Hotlines</h4>
                <div className="space-y-8">
                  {[
                    { label: 'Primary Contact', number: '070 570 5060' },
                    { label: 'Guest Relations', number: '071 754 9380' },
                    { label: 'Private Bookings', number: '071 322 3525' }
                  ].map((phone, idx) => (
                    <div key={idx} className="flex justify-between items-center border-b border-white/5 pb-6 last:border-0 last:pb-0 group">
                      <span className="text-stone-500 text-[10px] font-black uppercase tracking-widest">{phone.label}</span>
                      <a href={`tel:${phone.number.replace(/\s/g, '')}`} className="text-white font-bold text-xl serif group-hover:text-[#C5A059] transition-colors">{phone.number}</a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* REFINED: Room Section (The Mandodari Sanctuary) */}
      <section className="py-24 md:py-56 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20 md:mb-40 reveal">
             <h4 className="text-[#C5A059] uppercase tracking-[0.6em] font-black text-[9px] mb-6 md:mb-8">Accommodations</h4>
             <h2 className="text-4xl md:text-7xl lg:text-9xl font-bold serif text-white leading-[0.9] tracking-tighter">The Mandodari <br /><span className="italic text-[#C5A059] font-medium">Sanctuary.</span></h2>
          </div>

          <div className="grid gap-20 md:gap-40">
            {rooms.map((room, i) => (
              <div key={room.id} className={`flex flex-col ${i % 2 !== 0 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 md:gap-24 items-center reveal`}>
                <div className="lg:w-1/2 relative group/carousel overflow-hidden rounded-[2rem] md:rounded-[4rem] luxury-shadow photo-glow bg-stone-900 aspect-[16/10]">
                  <img src={(room.images && room.images.length > 0 && selectedRoom?.id === room.id) ? room.images[currentImgIndex] : room.image} className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-105" alt={room.name} />
                  <div className="absolute top-10 left-10 flex gap-2">
                    <span className="bg-black/40 backdrop-blur-md px-6 py-2 rounded-full text-[8px] font-black uppercase tracking-widest text-white border border-white/10">0{i+1}</span>
                  </div>
                </div>
                
                <div className="lg:w-1/2 space-y-8 md:space-y-12">
                  <div className="space-y-6">
                    <h3 className="text-3xl md:text-5xl lg:text-6xl font-bold serif text-white">{room.name}</h3>
                    <p className="text-stone-500 text-lg md:text-xl font-light italic leading-relaxed">
                      "{room.description}"
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-6 md:gap-10">
                    {room.amenities.map((a, idx) => (
                      <div key={idx} className="flex items-center gap-4 group">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#C5A059] group-hover:scale-150 transition-transform"></div>
                        <span className="text-[10px] md:text-xs font-black uppercase tracking-widest text-stone-400 group-hover:text-white transition-colors">{a}</span>
                      </div>
                    ))}
                  </div>

                  <div className="pt-8 md:pt-12 flex items-center justify-between border-t border-white/5">
                    <div>
                      <p className="text-stone-600 text-[10px] font-black uppercase tracking-widest mb-2 flex items-center gap-2">
                        Premium Request <button onClick={() => { setSelectedRoom(room); setCurrentImgIndex(0); }} className="text-[#C5A059] hover:underline normal-case tracking-normal ml-2">View Full Specs</button>
                      </p>
                      <p className="text-[#C5A059] text-3xl md:text-4xl font-bold serif italic">Private Rate</p>
                    </div>
                    <Link 
                      to="/booking" 
                      className="glow-button bg-white text-black px-10 md:px-14 py-4 md:py-6 rounded-full font-black uppercase tracking-widest text-[10px] shadow-2xl hover:bg-[#C5A059] transition-all"
                    >
                      Book Suite
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Elite Car Hire & Bespoke Mobility Section */}
      <section className="py-24 md:py-48 bg-[#0D0D0D] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-[#C5A059]/5 blur-[200px] rounded-full -translate-y-1/2 translate-x-1/2"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-3xl mb-24 reveal">
            <h4 className="text-[#C5A059] uppercase tracking-[0.6em] font-black text-[9px] mb-8">Bespoke Mobility</h4>
            <h2 className="text-4xl md:text-7xl serif text-white leading-[1.1] mb-10">Seamless <br /><span className="italic text-[#C5A059] font-medium">Transitions.</span></h2>
            <p className="text-stone-400 text-lg md:text-xl font-light leading-relaxed mb-12">
              From curated airport transfers in climate-controlled luxury to private chauffeur-driven excursions through the ancient kingdom, our elite fleet is designed for the discerning traveler.
            </p>
            
            <div className="grid md:grid-cols-3 gap-10">
              {[
                { icon: <Clock size={20} />, title: "24/7 Availability", desc: "Our fleet is ready at a moment's notice for any destination." },
                { icon: <Shield size={20} />, title: "Certified Chauffeurs", desc: "Expert drivers with intimate knowledge of the island." },
                { icon: <Navigation size={20} />, title: "Excursion Packages", desc: "Bespoke tours of sacred sites and hidden gems." }
              ].map((item, i) => (
                <div key={i} className="flex flex-col gap-4 group">
                  <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-[#C5A059] group-hover:scale-110 transition-transform">
                    {item.icon}
                  </div>
                  <div>
                    <h5 className="text-white font-bold serif text-lg mb-1">{item.title}</h5>
                    <p className="text-stone-500 text-sm font-light leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 reveal stagger-3">
            {[
              { 
                name: "Car", 
                type: "Toyota Prius Car", 
                img: "https://picture1.goo-net.com/100/1003167/J/1003167A30250425W00111.jpg",
                features: ["Eco-Luxury Hybrid", "Up to 4 Guests", "Climate Controlled Cabin"]
              },
              { 
                name: "Luxury Van", 
                type: "Toyota KDH", 
                img: "https://www.auto-lanka.com/img.web/UserImage/250910055458/thumb_a07051eb799dcff5020a666c7535ac0a1f656d87a0ca4b0f885f65231035d164.jpg",
                features: ["Executive Interior", "Up to 9 Guests", "Dual A/C System"]
              }
            ].map((car, idx) => (
              <div key={idx} className="bg-[#141414] border border-white/5 rounded-[2.5rem] p-10 hover:border-[#C5A059]/30 transition-all duration-700 group">
                <div className="aspect-video rounded-2xl overflow-hidden mb-8 photo-glow bg-stone-900">
                  <img src={car.img} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" alt={car.type} />
                </div>
                <h4 className="text-[#C5A059] text-[10px] font-black uppercase tracking-[0.4em] mb-2">{car.name}</h4>
                <h3 className="text-white text-3xl font-bold serif mb-8">{car.type}</h3>
                <ul className="space-y-4">
                  {car.features.map((f, i) => (
                    <li key={i} className="flex items-center gap-4 text-stone-400 text-sm font-light">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#C5A059]"></div> {f}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Full Specs Modal Overlay */}
      {selectedRoom && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10 animate-in fade-in duration-500">
          <div 
            className="absolute inset-0 bg-black/90 backdrop-blur-2xl cursor-pointer" 
            onClick={() => setSelectedRoom(null)}
          ></div>
          
          <div className="relative bg-[#0D0D0D] w-full max-w-6xl max-h-[90vh] overflow-y-auto rounded-[3rem] border border-white/10 luxury-shadow flex flex-col md:flex-row animate-in zoom-in slide-in-from-bottom-10 duration-700">
            <button 
              onClick={() => setSelectedRoom(null)}
              className="absolute top-8 right-8 z-[110] text-stone-400 hover:text-white transition-colors"
            >
              <X size={32} strokeWidth={1.5} />
            </button>

            <div className="md:w-[45%] h-[400px] md:h-auto shrink-0 relative group/carousel overflow-hidden">
              <img 
                src={(selectedRoom.images && selectedRoom.images.length > 0) ? selectedRoom.images[currentImgIndex] : selectedRoom.image} 
                className="w-full h-full object-cover transition-all duration-700" 
                alt={selectedRoom.name} 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              
              {selectedRoom.images && selectedRoom.images.length > 1 && (
                <>
                  <button 
                    onClick={(e) => { e.stopPropagation(); prevImage(); }}
                    className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/40 backdrop-blur-md border border-white/10 flex items-center justify-center text-white hover:bg-[#C5A059] hover:text-black transition-all opacity-0 group-hover/carousel:opacity-100"
                  >
                    <ChevronLeft size={24} />
                  </button>
                  <button 
                    onClick={(e) => { e.stopPropagation(); nextImage(); }}
                    className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/40 backdrop-blur-md border border-white/10 flex items-center justify-center text-white hover:bg-[#C5A059] hover:text-black transition-all opacity-0 group-hover/carousel:opacity-100"
                  >
                    <ChevronRight size={24} />
                  </button>
                  <div className="absolute top-10 left-10 bg-black/40 backdrop-blur-md px-4 py-1.5 rounded-full border border-white/10 text-[9px] font-black tracking-[0.2em] uppercase text-white">
                    {currentImgIndex + 1} / {selectedRoom.images.length}
                  </div>
                </>
              )}
              
              <div className="absolute bottom-10 left-10">
                <p className="text-[#C5A059] text-[10px] font-black tracking-[0.4em] uppercase mb-2">Signature Asset</p>
                <h2 className="text-4xl font-bold serif text-white italic">{selectedRoom.name}</h2>
              </div>
            </div>

            <div className="p-10 md:p-20 flex-grow space-y-12">
              <div className="space-y-6">
                <h4 className="text-[#C5A059] uppercase tracking-[0.6em] font-black text-[9px]">Technical Specifications</h4>
                <p className="text-stone-400 text-lg md:text-xl font-light leading-relaxed italic">
                  "{selectedRoom.description}"
                </p>
              </div>

              <div className="grid grid-cols-2 gap-8 py-8 border-y border-white/5">
                <div>
                  <p className="text-stone-500 text-[9px] uppercase tracking-widest font-black mb-2">Max Occupancy</p>
                  <p className="text-white text-xl font-bold serif">{selectedRoom.capacity} Elite Guests</p>
                </div>
                <div>
                  <p className="text-stone-500 text-[9px] uppercase tracking-widest font-black mb-2">Pricing Standard</p>
                  <p className="text-[#C5A059] text-xl font-bold serif italic">Inquiry Only</p>
                </div>
              </div>

              <div className="space-y-8">
                <h4 className="text-white uppercase tracking-[0.4em] font-black text-[10px]">Included Amenities</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-12">
                  {selectedRoom.amenities.map((amenity, idx) => (
                    <div key={idx} className="flex items-center gap-4 group">
                      <div className="w-2 h-2 rounded-full bg-[#C5A059] shadow-lg shadow-[#C5A059]/20 group-hover:scale-125 transition-transform"></div>
                      <span className="text-stone-400 text-[11px] font-black uppercase tracking-widest group-hover:text-white transition-colors">{amenity}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="pt-8">
                <Link 
                  to="/booking"
                  onClick={() => setSelectedRoom(null)}
                  className="glow-button w-full bg-[#C5A059] text-black py-6 rounded-full font-black uppercase tracking-[0.4em] text-[10px] shadow-2xl transition-all"
                >
                  Request Reservation
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Visual Poetry Gallery Preview */}
      <section className="py-24 md:py-48 bg-[#0D0D0D]">
        <div className="max-w-[1800px] mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center mb-16 md:mb-24 reveal">
            <div>
              <h4 className="text-[#C5A059] uppercase tracking-[0.6em] font-black text-[9px] mb-6">Atmosphere</h4>
              <h2 className="text-4xl md:text-7xl serif text-white leading-tight">Estate <span className="italic text-[#C5A059] font-medium">Glimpses.</span></h2>
            </div>
            <Link to="/gallery" className="mt-8 md:mt-0 glow-button inline-flex items-center gap-4 bg-white/5 border border-white/10 text-white px-10 py-4 rounded-full font-black uppercase tracking-[0.3em] text-[9px] hover:bg-[#C5A059] hover:text-black transition-all duration-700">
               <Camera size={14} /> View All Moments
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-4 h-auto md:h-[900px]">
            {galleryPreview.map((img, i) => (
              <div key={i} className={`reveal stagger-${i+1} group relative overflow-hidden rounded-[2.5rem] luxury-shadow photo-glow ${img.size}`}>
                <img 
                  src={img.url} 
                  className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-110" 
                  alt={img.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-700 flex flex-col justify-end p-10">
                  <h3 className="text-white text-2xl font-bold serif mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-700">{img.title}</h3>
                  <div className="flex items-center gap-2 text-[#C5A059] text-[9px] font-black uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all delay-150">
                    <Eye size={12} /> Explore Detail
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
